module.exports = __webpack_public_path__ + "img/icon_shares.291b0f38.svg";